import { AbstractResultList } from "@component/assets/AbstractListingCalculator/AbstractResultList";
import { getBankName } from "@component/assets/data/banks";
import { Button, List } from "bm-ui-kit";
import type { CommonOptions } from "bm-ui-kit";
import type { ReactNode } from "react";
import React from "react";
import { Col, Collapse, Container, Row } from "react-bootstrap";
import { RetailAccountLeadForm } from "../LeadForm/RetailAccountLeadForm";
import { RetailAccountResultItem } from "./RetailAccountResultItem";
import { getLeadCalculatorRequest } from "./domain";
import type {
	RetailAccountRequest,
	RetailAccountResponseItem,
	RetailAccountSearchParams,
	RetailAccountSort,
} from "./types";

export class RetailAccountResultList extends AbstractResultList<
	RetailAccountSearchParams,
	RetailAccountSort,
	RetailAccountRequest,
	RetailAccountResponseItem
> {
	protected sortOptions: CommonOptions<RetailAccountSort> = [
		{ label: "1. és 2. éves havi költség szerint", value: "FIRST_AND_SECOND_YEAR_TOTAL_FEE" },
		{ label: "1. éves havi költség szerint", value: "FIRST_YEAR_MONTHLY_TOTAL_FEE" },
		{ label: "2. éves havi költség szerint", value: "SECOND_YEAR_MONTHLY_EXPENSE" },
	];

	protected renderResult(props): ReactNode {
		return <RetailAccountResultItem {...props} />;
	}

	protected renderNormalListTitle(): ReactNode {
		return "Bankszámla ajánlataink";
	}

	protected renderBankSpecifictTitle(): ReactNode {
		const { highlightedBank } = this.props;

		return `${getBankName(highlightedBank)} bankszámlára vonatkozó ajánlatai`;
	}

	protected renderOtherBankTitle(): ReactNode {
		return "A legjobb találatok bankszámlára";
	}

	protected renderListingOffer(): ReactNode {
		const { searchParams } = this.props;
		const { showListingOffer } = this.state;

		return (
			<div className="listing-offer-block mb-3" key="listing-offer">
				<Container className="text-center my-3">
					<div className="h1 mb-3">Egyeztess szakértőnkkel díjmentesen,</div>
					<div className="mb-3">
						<strong>
							hogy választ kapj kérdéseidre, és megtaláljátok a számodra legkedvezőbb konstrukciót!
						</strong>
					</div>
					<Button size="lg" className="text-uppercase" onClick={this.onListingOfferClick}>
						Kapcsolatfelvétel
					</Button>
				</Container>
				<Collapse in={showListingOffer}>
					<div className="fluid-block text-white mt-3">
						<Container>
							<Row className="justify-content-center align-items-center flex-column-reverse flex-lg-row p-3">
								<Col className="text-block" lg={7}>
									<div className="h3 text-white font-weight-bold mt-3 mb-4">
										Bankszámlával kapcsolatos kérdések, melyek mindenkit foglalkoztatnak
									</div>
									<List itemStyle="tick" variant="gold">
										<List.Item>
											Nincs ingyen ebéd, <strong>hogyan lehet ingyenes egy bankszámla?</strong>
										</List.Item>
										<List.Item>Hogyan találhatom meg a számomra legolcsóbb számlát?</List.Item>
										<List.Item>Mely megbízások lesznek díjmentesek számomra?</List.Item>
										<List.Item>Lehet online is számlát nyitni?</List.Item>
									</List>
									<p>Kérdésed van, tedd fel szakértőnknek!</p>
								</Col>
								<Col className="pb-4 pb-lg-0" lg={5} md={8}>
									{showListingOffer && (
										<RetailAccountLeadForm
											{...this.getListingOfferLeadProps()}
											title="Kérj segítséget szakértőnktől!"
											request={getLeadCalculatorRequest(searchParams)}
										/>
									)}
								</Col>
							</Row>
						</Container>
					</div>
				</Collapse>
			</div>
		);
	}

	protected createViewItemListEventItem(result: RetailAccountResponseItem): Record<string, any> {
		const { firstYear, secondYear, discountPackageName = "" } = result;

		return {
			coupon: "none",
			currency: "HUF",
			discount: 0,
			item_category: `${firstYear.annualTotalFee}-${secondYear.annualTotalFee}`,
			item_category2: `${firstYear.annualCost}-${secondYear.annualCost}`,
			item_category3: `${firstYear.totalTransferCostAnnual}-${secondYear.totalTransferCostAnnual}`,
			item_category4: `${firstYear.cardUsageCostAnnual}-${secondYear.cardUsageCostAnnual}`,
			item_category5: `${firstYear.otherCostsAnnual}-${secondYear.otherCostsAnnual}`,
			item_variant: discountPackageName,
			price: 0,
			quantity: 0,
		};
	}

	protected getComponentName(): string {
		return "RetailAccountResultList";
	}
}
